/**
 * @author taoWu
 * @description 人脸认证信息采集明细
 * @Date 2022/10/10
 */
import React from 'react';
import {connect} from 'dva';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import moment from "moment";
import {Card, Table} from "antd";

let {WizContainer, WizReduxTemplate,modelUtils} = framework_tool;
let {WizBrowserExport, WizCard, WizTabs,WizTag, WizSpin, WizCol, WizRow, WizModal,WizList,WizTypography} = component_tool;
const { Title } = WizTypography;
let {checkStrLength, Session} = utils_tool;

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const formatterGender = (val) => {
  let newVal;
  switch (val) {
    case  0 :
      newVal = '男'
      break;
    case  1 :
      newVal = '女'
      break;
    case  2 :
      newVal = '未知'
      break;
    default :
      newVal = '无';
  }
  return newVal;
}
const formatterStatus = (val) => {
  let newVal;
  switch (val) {
    case  0 :
      newVal = '待验证'
      break;
    case  1 :
      newVal = '认证通过'
      break;
    case  2 :
      newVal = '认证失败'
      break;
    default :
      newVal = '无';
  }
  return newVal;
}
const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/org/person/personFaceAuthDetail') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('personFaceAuthInfo', record)
      } else {
        record = Session.get('personFaceAuthInfo') || {}
      }
    }
  }
  return record
}

class PersonFaceAuthDetail extends WizContainer {

  componentName = 'PersonFaceAuthDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let record = getParamRecord(history)
    let imgList = [];
    if (record!=null) {
      imgList.push({img: record.faceImg1, name: '头像照片'});
      imgList.push({img: record.faceImg2, name: '身份证照片'});
      // imgList.push({img: record.faceImg3, name: '手持身份证照'});
    }
    this.state = {
      time: undefined,
      personFaceAuthLog:[],
      imgList:imgList,
    }
    this.initialValue = record;
  }

  _componentDidMount() {
    if (this.initialValue.personId) {
      this.doAction({
        path: 'faceAuthLog/list',
        payload: {
          key: "personFaceAuthLogList",
          apiParams: {
            personId: this.initialValue.personId,
            type:56
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    personFaceAuthLog: this._getPersonFaceAuthLogOver.bind(this)
  }

  _getPersonFaceAuthLogOver(nextProps, nextState) {
    if (nextProps.personFaceAuthLog.code == 1) {
      nextState.personFaceAuthLog = nextProps.personFaceAuthLog.data;
      nextState.time = new Date().getTime();
    }
    return true;
  }

  _showPersonBaseInfo(record) {
    let content = <WizCard title={'个人基本信息'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
      <WizRow>
        <WizCol span={8} offset={2}>
          学员姓名: {record.fullName}
        </WizCol>
        <WizCol span={6}>
          学员账号: {record.userName}
        </WizCol>
        <WizCol span={8}>
          性别: {formatterGender(record.gender)}
        </WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={8} offset={2}>
        手机号码: {record.mobile}
        </WizCol>
       {/*  <WizCol span={6}>
          手机号码: {record.mobile}
        </WizCol> */}
        <WizCol span={8}>
        </WizCol>
      </WizRow>
    </WizCard>
    return content;
  }

  _showPersonFaceAuthInfo(record) {
    let content = <WizCard title={'人脸采集照片'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={24} style={{textAlign: 'center'}} offset={2}>
          <WizList grid={{gutter: 16, column: 4}}
                   bordered = {false}
                   dataSource={this.state.imgList}
                   renderItem={item => (
                     <WizList.Item>
                       {this._getImgInfo(item.img,item.name)}
                     </WizList.Item>
                   )}
          />
        </WizCol>
      </WizRow>
    </WizCard>
    return content;
  }

  _getImgInfo(img,imgName) {
    let unImgStr = '暂未采集';
    return(
    <>
      <div style={{textAlign: 'center',margin:'auto'}}>
        <div style={{display: 'flex', justifyContent: 'flex-start',textAlign: 'center'}}>
          {
            img!=null && img!='' && img!=undefined ? (
              <PhotoProvider
                toolbarRender={({ onScale, scale }) => {
                  return (
                    <>
                      <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale + 1)} />
                      <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale - 1)} />
                    </>
                  );
                }}>
                <div className="foo">
                  <PhotoView key={'face_auth_img_'+ 1+'_'+img} src={getOssFilePath(img)}>
                    <img style={{justifyContent: 'center',alignItems: 'center',margin:'auto',display:'block'}} height={200} width={200} src={getOssFilePath(img)} alt="" />
                  </PhotoView>
                </div>
              </PhotoProvider>
            ):(
              <div className="foo" >
                <div style={{
                  height: 200,
                  width: 200,
                  overflow: 'hidden',
                  position: 'relative',
                  padding: 50,
                  textAlign: 'center',
                }}>
                  <Title level={4} style={{color:'#108ee9'}}>{unImgStr}</Title>
                </div>
              </div>
            )
          }
        </div>
        {
          imgName ?
            (<div style={{textAlign: 'center',width:200, paddingTop: 10}}>
              {imgName}
            </div>) : null
        }
      </div>
    </>)
  }

  _showPersonFaceAuthLog() {
    let columns = this._columns({_getImgInfo:this._getImgInfo});
    let tableProps = {
      columns,
      dataSource: this.state.personFaceAuthLog,
      pagination: false,
      bordered: true,
      rowKey: 'id',
    }
    let content = <WizSpin tip={'加载中'} spinning={this.props.faceAuthLogLoading}>
      <WizCard key={'personFaceAuthLog_'+this.state.time } title={'人脸采集记录'}>
        <Table {...tableProps} />
      </WizCard>
    </WizSpin>
    return content;
  }
  _columns = ({_getImgInfo}) => {
    return [{
      title: '实名认证时间',
      name: 'invokTime',
      dataIndex: 'invokTime',
      align: 'center',
      width: 250,
      render: (v, r, i) => {
        log.info('r',r);
        return formatterMinute(r.invokTime)
      }
    }, {
      title: '实名认证状态',
      name: 'authenticationStatus',
      dataIndex: 'authenticationStatus',
      align: 'center',
      width: 250,
      render: (v, r, i) => {
        const {entityId } =r;
        let authType = '头像照认证';
        if (entityId != null && entityId ===2){
          authType = '身份证照认证';
        } else if (entityId != null && entityId ===3){
          authType = '手持身份证照认证';
        }
        return authType +': '+ formatterStatus(r.authenticationStatus)
      }
    }, {
      title: '照片信息',
      name: 'img',
      dataIndex: 'img',
      align: 'center',
      justifyContent:'center',
      alignItems:'center',
      width: 300,
      render: (v, r, i) => {
        let img = r.img;
        let imgName = null;
        let imgList_ = [];
        imgList_.push({img,name:null})
        return _getImgInfo &&  (
          <div style={{textAlign: 'center',margin:'auto',justifyContent: 'center',alignItems: 'center' }}>
            <WizRow>
              <WizCol span={24}>
                <WizList grid={{gutter: 16, column: 1}}
                         bordered = {false}
                         dataSource={imgList_}
                         renderItem={item => (
                           <WizList.Item>
                             {_getImgInfo(item.img,item.name)}
                           </WizList.Item>
                         )}
                />
              </WizCol>
            </WizRow>
          </div>)
      }
    }]
  }

  _render() {
    let record = this.initialValue;
    return <>
      <div>
        {this._showPersonBaseInfo(record)}
        {this._showPersonFaceAuthInfo(record)}
        {this._showPersonFaceAuthLog()}
      </div>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { faceAuthLog } = state;
  const personFaceAuthLog = modelUtils.getModelEntity(faceAuthLog, "personFaceAuthLogList");
  const load = modelUtils.getLoadingState(state, ['faceAuthLog']);
  return {
    personFaceAuthLog,
    ...load
  }
};

export default connect(mapStateToProps)(PersonFaceAuthDetail);
